import { put, call, takeLatest, select, all } from 'redux-saga/effects';
import invariant from 'invariant';
import _ from 'lodash';

import { LOAD_PLAYLISTS } from '../constants';
import { getPlaylists } from '../service';
import {
  pendingLoadPlaylists,
  playlistsLoaded,
  playlistsLoadingError,
} from '../actions';

export function* fetchPlaylists() {
  yield put(pendingLoadPlaylists());
  try {
    const response = yield call(getPlaylists);

    // invariant broken middleware
    const error = _.get(response, ['data', 'error'], false);
    invariant(!error, '(Music/player/saga...) fetchTrack: Service Error');

    const playlists = _.flow(
      obj => _.get(obj, ['data', 'response', 'components']),
      obj => _.keyBy(obj, 'type'),
    )(response);

    yield put(playlistsLoaded(playlists));
  } catch (error) {
    yield put(playlistsLoadingError(error));
  }
}

export default function* playlistSaga() {
  yield takeLatest(LOAD_PLAYLISTS.ACTION, fetchPlaylists);
}
